import { render, staticRenderFns } from "./MenuReorder.vue?vue&type=template&id=f378a376&scoped=true&"
import script from "./MenuReorder.vue?vue&type=script&lang=js&"
export * from "./MenuReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f378a376",
  null
  
)

export default component.exports